import { axiosV1, axiosV2 } from 'interceptors/axios';

import { PartnerCategory } from 'types/Partner';

import { decryptResponse } from 'utils/token';

export type CanjePreviewParticipant = {
  originPartnerId: string;
  holderName: string;
  currentShares: number;
  postExchangeOrigin: number;
  newSocietyShares: number;
  encumberedShares?: number;
  encumberedSharesExchanged?: number;
  encumberedSharesTarget?: number;
};

export type CanjePreviewResponse = {
  societyId: string;
  societyName: string;
  originShareClass: string | null;
  originShareClassName: string;
  participants: CanjePreviewParticipant[];
  ratioOld: number;
  ratioNew: number;
  errorKey: string | null;
};

export const fetchCanjePreview = async (params: {
  societyId: string;
  originShareClass: string;
  ratioOld: number;
  ratioNew?: number;
  excludedPartnerIds?: string[];
}): Promise<CanjePreviewResponse> => {
  const { data } = await axiosV2.get('/operations/canje/preview', {
    params: {
      societyId: params.societyId,
      originShareClass: params.originShareClass,
      ratioOld: params.ratioOld,
      ratioNew: params.ratioNew ?? 1,
      ...(params.excludedPartnerIds?.length
        ? { excludedPartnerIds: params.excludedPartnerIds }
        : {}),
    },
  });

  return (await decryptResponse(data)) as CanjePreviewResponse;
};

/** Carga categorías de socio por sociedad sin tocar Redux (p. ej. modal Canje con dos sociedades). */
export const fetchPartnerCategoriesForSociety = async (
  societyId: string
): Promise<PartnerCategory[]> => {
  if (!societyId) {
    return [];
  }
  const { data } = await axiosV1.get('/partnerCategories', {
    params: { societyId },
  });
  const decoded = await decryptResponse(data);
  return Array.isArray(decoded) ? (decoded as PartnerCategory[]) : [];
};

export const postCanjeOperation = async (
  body: Record<string, unknown>
): Promise<Record<string, unknown>> => {
  const { data } = await axiosV2.post('/operations/canje', body);

  return (await decryptResponse(data)) as Record<string, unknown>;
};
